// @ts-check
import { gql, useQuery } from '@apollo/client';
import React from 'react';
import DefaultImportInProgressPage from '../../../../components/ImportComplete/DefaultImportInProgressPage';
import DefaultImportStateErrorPage from '../../../../components/ImportComplete/DefaultImportStateErrorPage';
import DefaultImportWithErrorPage from '../../../../components/ImportComplete/DefaultImportWithErrorPage';
import ImportCompletePage from '../../../../components/ImportComplete/productDataImport/ImportCompletePage';

export default function Complete({ match }) {
  const { workspaceId, importId } = match.params;
  const { loading, data, startPolling, stopPolling } = useQuery(query, {
    variables: { workspaceId, importId },
  });
  const importData = data?.workspace?.dataImport;
  const state = importData?.state?.state;
  React.useEffect(() => {
    if (['STARTED', 'JOB_IN_PROGRESS'].includes(state)) {
      startPolling(1000);
    }
    return () => {
      stopPolling();
    };
  }, [data, state, startPolling, stopPolling]);

  if (loading) return null;
  if (state !== 'JOB_IN_PROGRESS') {
    stopPolling();
  }

  if (state === 'JOB_IN_PROGRESS') {
    return <DefaultImportInProgressPage importData={importData} />;
  }
  if (state === 'COMPLETED') {
    return <ImportCompletePage importData={importData} />;
  }
  if (state === 'ERROR') {
    return <DefaultImportWithErrorPage importData={importData} />;
  }
  return <DefaultImportStateErrorPage importData={importData} />;
}

/** @type {typeof import('./complete.generated').ImportCompletePageDocument} */
const query = gql`
  query ImportCompletePage($workspaceId: ID!, $importId: ID!) {
    workspace(workspaceId: $workspaceId) {
      workspaceId
      dataImport(importId: $importId) {
        importId
        collectionId
        outputUrl
        state {
          state
          progress
        }
      }
    }
  }
`;
